<button
    [attr.role]="'link'"
    [attr.aria-labelledby]="'back-button-label-' + buttonId"
    class="back-button"
    [class.auto-add-margin]="autoAddMargin"
    [class.auto-add-new-mobile-back-button-background]="displaySmallMobileBackButton"
    #backButton
    (click)="handleGoBack()">
    <!-- Mobile back button arrow -->
    @if (displaySmallMobileBackButton) {
    <svg:svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="7"
        viewBox="0 0 10 8"
        class="mobile-only"
        [attr.aria-hidden]="'true'"
        focusable="false">
        <svg:g fill="none" fill-rule="evenodd" stroke="#444" stroke-linecap="round" stroke-width="1.2">
            <svg:path d="M3.704 1.481L1.48 3.704l2.223 2.222M1.851 3.703h6.667" />
        </svg:g>
    </svg:svg>
    }

    <!-- Default back button arrow -->
    <svg:svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="16"
        [class.desktop-only]="displaySmallMobileBackButton"
        [attr.aria-hidden]="'true'"
        focusable="false">
        <svg:g fill="none" fill-rule="evenodd" stroke="#333" stroke-linecap="round" stroke-width="2">
            <svg:path d="M10 1L2 8l8 7M4 8h21.1874547" />
        </svg:g>
    </svg:svg>
    <span class="back-text paragraph-medium" id="back-button-label-{{ buttonId }}">
        <ng-content></ng-content>
    </span>
</button>
